import './App.css'
import Header from './components/Header'
import MainContainer from './components/MainContainer'
import SessionsList from './components/SessionsList'
import CreateEvent from './pages/CreateEvent'
import { Routes, Route, BrowserRouter } from 'react-router-dom'
import HomePage from './pages/HomePage'
import LoginPage from './pages/LoginPage'
import RequireAuth from './components/require-auth/RequireAuth'
import RequireGuest from './components/require-guest/RequireGuest'
import InitializeAuth from './components/initialize-auth/InitializeAuth'
import AuthorizeRedirectPage from './pages/AuthorizeRedirectPage'
import { ROUTES } from './routes'
import EmailConfirmationPage from './pages/EmailConfirmationPage'
import EmailConfirmedPage from './pages/EmailConfirmedPage'
import ResetPasswordPage from './pages/ResetPasswordPage'
import ResetPasswordEmailSentPage from './pages/ResetPasswordEmailSentPage'

function App() {

  return (
    <InitializeAuth>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        {/* Header  */}
        <Header />
        <MainContainer>
          <Routes>
            <Route path={ROUTES.SESSIONS} element={
              <RequireAuth>
                <SessionsList />
              </RequireAuth>} />
            <Route path={ROUTES.CREATE_SESSION} element={
              <RequireAuth>
                <CreateEvent />
              </RequireAuth>} />
            <Route path={ROUTES.HOME} element={
              <RequireAuth>
                <HomePage />
              </RequireAuth>} />
            <Route path={ROUTES.HOME_PAGE} element={
              <RequireAuth>
                <HomePage />
              </RequireAuth>} />
            <Route path={ROUTES.LOGIN} element={
              <RequireGuest>
                <LoginPage />
              </RequireGuest>
            } />
            <Route
              path={ROUTES.AUTHORIZE_REDIRECT}
              element={<AuthorizeRedirectPage />}
            />
            <Route
              path={ROUTES.EMAIL_CONFIRMATION}
              element={
                <RequireGuest>
                  <EmailConfirmationPage />
                </RequireGuest>
              }
            />
            <Route
              path={ROUTES.EMAIL_CONFIRMED}
              element={
                <RequireGuest>
                  <EmailConfirmedPage />
                </RequireGuest>
              }
            />
            <Route
              path={ROUTES.RESET_PASSWORD}
              element={
                <RequireGuest>
                  <ResetPasswordPage />
                </RequireGuest>
              }
            />
            <Route
              path={ROUTES.RESET_PASSWORD_EMAIL_SENT}
              element={
                <RequireGuest>
                  <ResetPasswordEmailSentPage />
                </RequireGuest>
              }
            />
          </Routes>

        </MainContainer>

      </BrowserRouter>
    </InitializeAuth>

  )
}

export default App
